import apiRequest from '../../../shared/services/apiClient';

export interface RevokeRefreshTokensRequest {
  employeeId?: string;
}

export interface RevokeRefreshTokensResponse {
  revokedCount: number;
  revokedAtUtc: string;
  scope: 'tenant' | 'employee' | string;
  employeeId: string | null;
}

export const revokeRefreshTokens = async (
  request: RevokeRefreshTokensRequest
): Promise<RevokeRefreshTokensResponse> => {
  const payload = request.employeeId?.trim()
    ? { employeeId: request.employeeId.trim() }
    : {};

  return apiRequest<RevokeRefreshTokensResponse>('/api/v1/auth/revoke-refresh-tokens', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
};